// extracted by mini-css-extract-plugin
module.exports = {"component":"TeamsPage_component__JVPOq","content":"TeamsPage_content__37PVG","button":"TeamsPage_button__2-A-0","header":"TeamsPage_header__1zYA_"};